module.exports = __webpack_public_path__ + "a7b9cea1025fb8c6fedffe6ff3fae1b6.svg";